function InfoIcon({ ...rest }) {
  return (
    <svg
      width='17'
      height='18'
      viewBox='0 0 17 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M8.44506 16.0521C12.4193 16.0521 15.6411 12.8233 15.6411 8.84027C15.6411 4.85727 12.4193 1.62842 8.44506 1.62842C4.4708 1.62842 1.24902 4.85727 1.24902 8.84027C1.24902 12.8233 4.4708 16.0521 8.44506 16.0521Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.44434 11.7249V8.84021'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.44434 5.95557H8.45134'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default InfoIcon;
